module.exports = __webpack_public_path__ + "static/media/icons8-github.6a8f33d6.svg";